export enum OnboardingStatus {
	AVAILABLE = 'AVAILABLE',
	WAITING_FOR_PREVIOUS_KEYS = 'WAITING_FOR_PREVIOUS_KEYS',
	WAITING_FOR_CONDITION = 'WAITING_FOR_CONDITION',
	ALREADY_SEEN = 'ALREADY_SEEN',
}
